/**
 * Site content model — everything the admin can edit lives in this shape.
 * The published document is stored as JSON in the `site-content` blob
 * container; the public site falls back to the baked-in defaults when no
 * published document exists.
 */
/** Icons available for intro blocks — rendered by @denise-augusta/ui. */
export const INTRO_ICON_OPTIONS = [
    { id: 'clock', label: 'Clock' },
    { id: 'dollar', label: 'Dollar' },
    { id: 'globe', label: 'Globe' },
    { id: 'calendar', label: 'Calendar' },
    { id: 'mail', label: 'Mail' },
    { id: 'check', label: 'Check' },
    { id: 'star', label: 'Star' },
    { id: 'heart', label: 'Heart' },
    { id: 'briefcase', label: 'Briefcase' },
    { id: 'phone', label: 'Phone' },
    { id: 'shield', label: 'Shield' },
    { id: 'zap', label: 'Lightning' },
    { id: 'users', label: 'People' },
    { id: 'sun', label: 'Sun' },
];
export const DEFAULT_SITE_MODE = 'locked';
/** Supported Claude models for the AI-assist features. */
export const CLAUDE_MODELS = [
    { id: 'claude-fable-5', label: 'Claude Fable 5' },
    { id: 'claude-opus-4-8', label: 'Claude Opus 4.8' },
    { id: 'claude-sonnet-5', label: 'Claude Sonnet 5' },
    { id: 'claude-haiku-4-5-20251001', label: 'Claude Haiku 4.5' },
];
export const defaultPortalSettings = {
    llm: {
        provider: 'anthropic',
        apiKey: '',
        model: 'claude-sonnet-5',
    },
    updatedAt: '1970-01-01T00:00:00.000Z',
};
export const SUBMISSION_STATUSES = ['new', 'read', 'archived'];
export const defaultNotificationSettings = {
    enabled: true,
    recipients: [],
    subjectPrefix: 'New inquiry',
    updatedAt: '1970-01-01T00:00:00.000Z',
};
//# sourceMappingURL=types.js.map